// src/services/ticketDetail.js

/**
 * Fetch a ticket detail.
 * @param {(args:{url:string, params?:object, headers?:object})=>Promise<any>} requestFn - usually executeGet
 * @param {string|number} ticketId
 */
export async function fetchTicketDetail(requestFn, ticketId) {
  return requestFn({ url: `boost/tickets/${encodeURIComponent(ticketId)}` });
}

/**
 * Post an admin message.
 * Body: { text, image? }
 * @param {(args:{url:string, data:any, headers?:object})=>Promise<any>} postFn - usually executePost
 * @param {string|number} ticketId
 * @param {{ text: string, image?: string|null }} payload
 */
export async function postAdminMessage(postFn, ticketId, { text, image }) {
  const trimmed = (text ?? '').trim();
  const body = image ? { text: trimmed, image } : { text: trimmed };

  return postFn({
    url: `boost/tickets/${encodeURIComponent(ticketId)}/messages`,
    data: body,
    // NOTE: executePost sets Content-Type automatically, but being explicit for JSON is fine.
    headers: { 'Content-Type': 'application/json' },
  });
}

/**
 * Upload an attachment (multipart/form-data).
 * IMPORTANT: Do NOT set Content-Type — the browser/axios will set the boundary.
 * @param {(args:{url:string, data:FormData})=>Promise<any>} postFn - usually executePost
 * @param {{ assignmentId: string|number, ticketId: string|number, file: File }} args
 */
export async function uploadAttachment(postFn, { assignmentId, ticketId, file }) {
  const form = new FormData();
  form.append('assignment_id', String(assignmentId));
  form.append('ticket_id', String(ticketId));
  form.append('file', file);

  return postFn({
    url: `boost/attachments`,
    data: form,
    // No headers here → let axios set multipart boundary
  });
}

/**
 * OPTIONAL: helper to build secure static URLs for attachments (keeps UI DRY).
 * Backend returns paths like: "attachments/<aid>/<tid>/<file>"
 */
// export function buildStaticAttachmentUrl(raw) {
//   if (!raw) return '';
//   const clean = String(raw).replace(/^\/+/, ''); // strip leading slashes
//   return `/api/boost/static/${clean.replace(/^attachments\//, '')}`;
// }
